import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseServiceClient } from '../../../../../../shared/data/src/lib/client/base-service-client';
import { MfDocumentDto } from '../../../../../../shared/data/src/lib/dto/common/document-dto';
import { CustomerReportClaimDto } from '../interface/dto/features/report-claim/customer-report-claim-dto';
import { ReportClaimBodyDto } from '../interface/dto/features/report-claim/report-claim-request-dto';
import { ReportClaimResponseDto } from '../interface/dto/features/report-claim/report-claim-response-dto';
@Injectable({
    providedIn: 'root',
})
export class ReportClaimServiceClientService extends BaseServiceClient {
    private readonly BaseUrl = `${this.ApiBaseUrl}${this.appConstants.httpClient.mcaBase}`;

    public sendReportClaim(data: ReportClaimBodyDto): Observable<ReportClaimResponseDto> {
        return this.post(`${this.BaseUrl}/report-claims/`, data);
    }

    public getCustomerReportClaims(customerId: string): Observable<CustomerReportClaimDto[]> {
        return this.get(`${this.BaseUrl}/customers/${customerId}/report-claims`);
    }

    public cancelReportClaim(customerId: string, claimId: string): Observable<unknown> {
        return this.put(`${this.BaseUrl}/customers/${customerId}/report-claims/${claimId}/cancel`);
    }

    public getMedifitDocument(reportClaimId: string, customerId: string, maskedDocumentId: string): Observable<MfDocumentDto> {
        const url = `${this.BaseUrl}/customers/${customerId}/report-claims/${reportClaimId}/documents/${maskedDocumentId}`;
        return this.fetchDocument(url);
    }

    public getExternalDocument(reportClaimId: string, customerId: string, documentId: string): Observable<MfDocumentDto> {
        const url = `${this.BaseUrl}/customers/${customerId}/report-claims/${reportClaimId}/external/documents/${documentId}`;
        return this.fetchDocument(url);
    }
}
